import { AlertCircle, WifiOff } from "lucide-react";

import type { RendererProps } from "../types";

import { getUserFacingCellError } from "@/routes/smart-table/utils/cellDisplayState";

export function ErrorRenderer({ content }: RendererProps) {
  const userFacingError = getUserFacingCellError(content.displayPreview);
  const Icon = userFacingError.isNetworkError ? WifiOff : AlertCircle;

  return (
    <div className="rounded-lg border border-red-200/80 bg-red-50/80 p-5 dark:border-red-900/40 dark:bg-red-950/20">
      <div className="mb-3 flex items-center gap-2">
        <Icon className="h-4 w-4 flex-shrink-0 text-red-500 dark:text-red-400" />
        <span className="text-sm font-medium text-red-700 dark:text-red-300">
          {userFacingError.title}
        </span>
      </div>
      <pre className="overflow-x-auto whitespace-pre-wrap break-all rounded-md bg-red-100/60 p-4 font-mono text-xs leading-relaxed text-red-800 dark:bg-red-950/30 dark:text-red-200">
        {userFacingError.message}
      </pre>
    </div>
  );
}
